const INSURANCE_ELIGIBLE_LOCATIONS = new Set(["CCI_INDIA", "IVYCLINIC"]);
const INSURANCE_INELIGIBLE_EMPLOYEE_TYPES = new Set(["CONSULTANT"]);

export function isInsuranceEligibleLocation(
  location?: string | null,
  employeeType?: string | null,
): boolean {
  const normalizedEmployeeType = String(employeeType ?? "").trim().toUpperCase();
  return !INSURANCE_INELIGIBLE_EMPLOYEE_TYPES.has(normalizedEmployeeType) &&
    INSURANCE_ELIGIBLE_LOCATIONS.has(
      String(location ?? "").trim().toUpperCase(),
    );
}
